import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { format } from "date-fns";
import { baseUrl, Fetch, ILazyParams } from "../../shared/Fetch";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Accordion, AccordionTab } from "primereact/accordion";
import { EmptyFilterTimesheet, Filter, IFilterTimesheet } from "./Filter";
import { Toolbar } from "primereact/toolbar";
import { Form } from "./Form";
import "./TimesheetStyle.css";
import { SendEmail } from "./SendEmail";
import { Dialog } from "primereact/dialog";
import { ILogin } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { POStatus } from "../../models/PurchaseOrder";
import { VerifyStatus } from "../../models/Timesheet";
import { POStatusMap } from "../../models/FDropdown";

interface IProps {
    toast: any,
}

interface ITimesheet {
    pO_Id?: number | null,
    pO_Date?: Date,
    consultant_ID?: number | null,
    consultant_Name?: string | null,
    req_Job_Title?: string | null,
    project_Client_Name?: string | null,
    location?: string | null,
    vendor_Company_Name?: string | null,
    sub_Vendor_Company?: string | null,
    pO_Status?: POStatus | null,
    project_Start_Date?: Date | null,
    project_End_Date?: Date | null,
    isWeek1?: boolean,
    isWeek2?: boolean,
    isWeek3?: boolean,
    isWeek4?: boolean,
    isWeek5?: boolean,
    isWeek6?: boolean,
    week1?: number,
    week2?: number,
    week3?: number,
    week4?: number,
    week5?: number,
    week6?: number,
    week1TimesheetID?: number,
    week2TimesheetID?: number,
    week3TimesheetID?: number,
    week4TimesheetID?: number,
    week5TimesheetID?: number,
    week6TimesheetID?: number,
    week1From?: Date,
    week1To?: Date,
    week2From?: Date,
    week2To?: Date,
    week3From?: Date,
    week3To?: Date,
    week4From?: Date,
    week4To?: Date,
    week5From?: Date,
    week5To?: Date,
    week6From?: Date,
    week6To?: Date,
    week1TimesheetHours?: string,
    week2TimesheetHours?: string,
    week3TimesheetHours?: string,
    week4TimesheetHours?: string,
    week5TimesheetHours?: string,
    week6TimesheetHours?: string,
    week1timeSheet_Path?: string,
    week1comments?: string,
    week1isNotWorking?: boolean,
    week1Verify_Status?: VerifyStatus,
    week2timeSheet_Path?: string,
    week2comments?: string,
    week2isNotWorking?: boolean,
    week2Verify_Status?: VerifyStatus,
    week3timeSheet_Path?: string,
    week3comments?: string,
    week3isNotWorking?: boolean,
    week3Verify_Status?: VerifyStatus,
    week4timeSheet_Path?: string,
    week4comments?: string,
    week4isNotWorking?: boolean,
    week4Verify_Status?: VerifyStatus,
    week5timeSheet_Path?: string,
    week5comments?: string,
    week5isNotWorking?: boolean,
    week5Verify_Status?: VerifyStatus,
    week6timeSheet_Path?: string,
    week6comments?: string,
    week6isNotWorking?: boolean,
    week6Verify_Status?: VerifyStatus,
    totalWorkHours?: number,
    monthTotalHours?: number,
    noTimesheetsInLastDays?: boolean,
    addedByWeek1?: string,
    addedByWeek2?: string,
    addedByWeek3?: string,
    addedByWeek4?: string,
    addedByWeek5?: string,
    addedByWeek6?: string,
    billing_Cycle?: boolean,
}

export const Table = (props: IProps) => {
    const [tableData, setTableData] = React.useState<{ tableData: any[], loading: boolean }>({ tableData: [], loading: false });
    const [modal, setModal] = useState<{ singleData: any, open: boolean, data: any }>({ singleData: {}, open: false, data: {} });
    const [filterData, setFilterData] = React.useState<IFilterTimesheet>(EmptyFilterTimesheet);
    const [totalRecords, setTotalRecords] = useState(0);
    const [selectedConsultant, setSelectedConsultant] = useState<Array<ITimesheet>>([]);
    const [openMailBox, setOpenMailBox] = useState({ open: false, multiData: [] } as { open: boolean, multiData: ITimesheet[] });
    const [openRules, setOpenRules] = useState<boolean>(false);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 50,
        page: 1,
        sortField: 'consultant_ID',
        sortOrder: -1
    });
    const dt = React.useRef<any>(null);

    const consultant_Name = (rowData: ITimesheet) => {
        const currentDate = new Date();
        return (
            <p className={rowData.noTimesheetsInLastDays === true ? "glow-loop" : ""}>{rowData.consultant_Name}</p>
        );
    };

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }
    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const startDate = (rowData: ITimesheet) => {
        let date;
        if (rowData.project_Start_Date) date = format(new Date(rowData.project_Start_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const endDate = (rowData: ITimesheet) => {
        let date;
        if (rowData.project_End_Date) date = format(new Date(rowData.project_End_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const loadTableData = async (filters: IFilterTimesheet) => {
        setTableData({ tableData: tableData.tableData, loading: true });

        if (filters.consultant !== null && filters.consultant && filters.consultant?.consultant_ID > 0) {
            filters.consultant_Name = filters.consultant.consultant_Name;
        }
        delete filters.consultant;

        if (filters.companyName !== null && filters.companyName && filters.companyName?.vendor_Company_ID && filters.companyName?.vendor_Company_ID > 0) {
            filters.sub_Vendor_Company = filters.companyName.vendor_Company_Name;
        }
        delete filters.companyName;

        if (filters.companyName2 !== null && filters.companyName2 && filters.companyName2?.vendor_Company_ID && filters.companyName2?.vendor_Company_ID > 0) {
            filters.vendor_Company_Name = filters.companyName2.vendor_Company_Name;
        }
        delete filters.companyName2;


        const response = await Fetch("Timesheet/getTimesheetListing", "GET", null, `filter=${JSON.stringify(filters)}&lazyParams=${JSON.stringify(lazyParams)}`, props.toast);
        if (response) {
            const data: { data: Array<ITimesheet>, count: number } = await response.json();
            const dataA: Array<ITimesheet> = data.data;
            setSelectedConsultant([]);
            setTableData({ tableData: dataA, loading: false });
            setTotalRecords(data.count);
        }
    };

    const openEmailDialog = () => {
        setOpenMailBox({ open: true, multiData: selectedConsultant });
    }

    const leftToolbarTemplate = () => {
        return <React.Fragment>
            <Button icon="pi pi-refresh" className="p-button-rounded p-button-info mr-2" onClick={() => loadTableData(filterData)} />
        </React.Fragment>;
    };

    const rightToolbarTemplate = () => {
        return <React.Fragment>
            {selectedConsultant.length > 0 && <Button tooltip="Send Email For Asking For Pending Timesheets" placeholder="Top" label="Send Email" icon="pi pi-envelope" onClick={() => openEmailDialog()} />}
            <Button tooltip="Help" placeholder="Bottom" icon="pi pi-info-circle" className="p-button-rounded p-button-info mr-2" onClick={() => setOpenRules(true)} />
        </React.Fragment>;
    };

    const rowWeek = (weekType: string, rowData: any) => {
        return <p onClick={() => {
            if (new Date(new Date(rowData?.[`week${weekType}To`] || "").getFullYear(), (new Date(rowData?.[`week${weekType}To`] || "").getMonth() + 1), new Date(rowData?.[`week${weekType}To`] || "").getDate()) > new Date(new Date().getFullYear(), (new Date().getMonth() + 1), new Date().getDate())) {
                props.toast.current.show({ severity: 'error', content: "Week Not Started Yet.." });
            } else if (rowData?.[`isWeek${weekType}`] && rowData?.[`week${weekType}`] !== -2 && rowData?.[`week${weekType}`] !== -3 && rowData?.[`week${weekType}Verify_Status`] !== VerifyStatus.Verified) {
                setModal({
                    open: true, singleData: {
                        fromDate: new Date(rowData?.[`week${weekType}From`] || ""),
                        toDate: new Date(rowData?.[`week${weekType}To`] || ""),
                        workHours: rowData?.[`week${weekType}TimesheetHours`] ? rowData?.[`week${weekType}TimesheetHours`].split(", ")[0] : 0,
                        overlapWorkHours: rowData?.[`week${weekType}TimesheetHours`] ? rowData?.[`week${weekType}TimesheetHours`].split(", ")[1] : 0,
                        timeSheet_Path: rowData?.[`week${weekType}timeSheet_Path`],
                        comments: rowData?.[`week${weekType}comments`],
                        isNotWorking: rowData?.[`week${weekType}isNotWorking`],
                        timeSheet_Status: (rowData?.[`week${weekType}Verify_Status`] === VerifyStatus.Verified) ? true : (rowData?.[`week${weekType}Verify_Status`] === VerifyStatus.Rejected ? false : null),
                    }, data: {
                        timesheet_ID: rowData?.[`week${weekType}TimesheetID`],
                        pO_Id: rowData.pO_Id,
                        consultant_ID: rowData.consultant_ID,
                        consultant_Name: rowData.consultant_Name,
                        project_Client_Name: rowData.project_Client_Name,
                        vendor_Company_Name: rowData.vendor_Company_Name,
                        sub_Vendor_Company: rowData.sub_Vendor_Company,
                        project_Start_Date: rowData.project_Start_Date,
                        project_End_Date: rowData.project_End_Date,
                        pO_Status: rowData.pO_Status,
                        pO_Date: rowData.pO_Date,
                        billing_Cycle: rowData.billing_Cycle,
                    }
                });
            }
        }}
            style={{
                color: (rowData?.[`week${weekType}Verify_Status`] === VerifyStatus.Rejected) ?
                    "black" :
                    ((rowData?.[`week${weekType}Verify_Status`] === VerifyStatus.Verified || rowData?.[`week${weekType}Verify_Status`] === 'Not Worked') ? "white" : "#1976D2"),
                paddingLeft: "5px",
                height: "100%",
                paddingTop: "5px",
                backgroundColor: (rowData?.[`week${weekType}Verify_Status`] === null || rowData?.[`week${weekType}Verify_Status`] === 'UnVerified' || rowData?.[`week${weekType}Verify_Status`] === VerifyStatus.Pending) ?
                    "yellow" :
                    (rowData?.[`week${weekType}Verify_Status`] === 'Not Worked' ?
                        "blue" :
                        (rowData?.[`week${weekType}Verify_Status`] === VerifyStatus.Rejected ?
                            "red" :
                            (rowData?.[`week${weekType}Verify_Status`] === VerifyStatus.Verified ? "green" : "")
                        )
                    )
            }}
            className={(rowData?.[`isWeek${weekType}`] && rowData?.[`week${weekType}`] !== -2 && rowData?.[`week${weekType}`] !== -3) ?
                "cursor-pointer underline" :
                ""
            }>{rowData?.[`isWeek${weekType}`] ?
                (rowData?.[`week${weekType}`] === -1 ?
                    ((new Date(new Date(rowData?.[`week${weekType}To`] || "").getFullYear(), new Date(rowData?.[`week${weekType}To`] || "").getMonth(), new Date(rowData?.[`week${weekType}To`] || "").getDate()) > new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())) ? "WNS" : "NC") :
                    (rowData?.[`week${weekType}`] === -2 ?
                        "PNS" :
                        (rowData?.[`week${weekType}`] === -3 ?
                            "End" :
                            rowData?.[`week${weekType}`]
                        )
                    )
                ) : "-"}</p>
    }

    const onHideTimesheetUpdate = () => {
        setSelectedConsultant([]);
        setModal({ open: false, singleData: {}, data: {} });
    }

    //OverlapWorkHours
    useEffect(() => {
        loadTableData(filterData);
    }, [filterData, lazyParams]);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj?.date_Format;
    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate} ></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter singleData={filterData} setFilterData={(filterData: IFilterTimesheet) => setFilterData(filterData)} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                lazy
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[50, 100, 200]}
                totalRecords={totalRecords} onPage={onPage} size="small" stripedRows showGridlines responsiveLayout="scroll"
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                emptyMessage="No Timesheet found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                value={tableData.tableData}
                header={<p>TIMESHEET</p>}
                loading={tableData.loading}
                selection={selectedConsultant}
                selectionMode={'checkbox'}
                onSelectionChange={(e) => {
                    const value = e.value as ITimesheet[];
                    setSelectedConsultant(value);
                }}
                dataKey="pO_Id"
            >
                <Column selectionMode="multiple" />
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="company_Name" header="Company (Branch)" body={(rowData: any) => <p>{rowData.company_Name} ({rowData.branchName})</p>} />
                <Column field="consultant_Name" header="Name" body={consultant_Name} />
                <Column field="req_Job_Title" header="Job Title" />
                <Column field="project_Client_Name" header="End Client" />
                <Column field="location" header="Location" />
                <Column field="vendor_Company_Name" header="Prime Vendor" />
                <Column field="sub_Vendor_Company" header="Sub Vendor" />
                <Column field="pO_Status" header="PO Status" body={r => r.pO_Status ? POStatusMap[r.pO_Status] : ''} />
                {/* <Column field="project_Start_Date" header="Project Start Date" body={startDate} /> */}
                <Column field="project_Start_Date" header="Project Start Date" style={{ minWidth: '100px' }} body={(rowData: any) => safeFormatDate(rowData.project_Start_Date, "dd/MM/yyyy", DateFormat)} />
                {/* <Column field="project_End_Date" header="Project End Date" body={endDate} /> */}
                <Column field="project_End_Date" header="Project End Date" style={{ minWidth: '100px' }} body={(rowData: any) => safeFormatDate(rowData.project_End_Date, "dd/MM/yyyy", DateFormat)} />
                <Column field="" style={{ minWidth: "46rem" }} header={<p style={{ width: "46rem", textAlign: "center", fontWeight: "bold" }}>Timesheets of {new Date(filterData.month || "").toLocaleString("en-US", { month: "long" })} - {new Date(filterData.month || "").getFullYear()}</p>} body={(rowData: ITimesheet) => {
                    const data = [
                        {
                            name: "1",
                            fields: "week1",
                            headers: `(${new Date(rowData.week1From || "").getDate()}/${new Date(rowData.week1From || "").getMonth() + 1}) to (${new Date(rowData.week1To || "").getDate()}/${new Date(rowData.week1To || "").getMonth() + 1})`,
                            data: rowData,
                            color: rowData.addedByWeek1 === "In" ? "blue" : (rowData.addedByWeek1 === "Cons" ? "green" : (rowData.addedByWeek1 === "Sub" ? "orange" : (rowData.addedByWeek1 === "Acc" ? "#ca03fc" : "black"))),
                            isWeek: rowData.isWeek1
                        },
                        {
                            name: "2",
                            fields: "week2",
                            headers: `(${new Date(rowData.week2From || "").getDate()}/${new Date(rowData.week2From || "").getMonth() + 1}) to (${new Date(rowData.week2To || "").getDate()}/${new Date(rowData.week2To || "").getMonth() + 1})`,
                            data: rowData,
                            color: rowData.addedByWeek2 === "In" ? "blue" : (rowData.addedByWeek2 === "Cons" ? "green" : (rowData.addedByWeek2 === "Sub" ? "orange" : (rowData.addedByWeek2 === "Acc" ? "#ca03fc" : "black"))),
                            isWeek: rowData.isWeek2
                        },
                        {
                            name: "3",
                            fields: "week3",
                            headers: `(${new Date(rowData.week3From || "").getDate()}/${new Date(rowData.week3From || "").getMonth() + 1}) to (${new Date(rowData.week3To || "").getDate()}/${new Date(rowData.week3To || "").getMonth() + 1})`,
                            data: rowData,
                            color: rowData.addedByWeek3 === "In" ? "blue" : (rowData.addedByWeek3 === "Cons" ? "green" : (rowData.addedByWeek3 === "Sub" ? "orange" : (rowData.addedByWeek3 === "Acc" ? "#ca03fc" : "black"))),
                            isWeek: rowData.isWeek3
                        },
                        {
                            name: "4",
                            fields: "week4",
                            headers: `(${new Date(rowData.week4From || "").getDate()}/${new Date(rowData.week4From || "").getMonth() + 1}) to (${new Date(rowData.week4To || "").getDate()}/${new Date(rowData.week4To || "").getMonth() + 1})`,
                            data: rowData,
                            color: rowData.addedByWeek4 === "In" ? "blue" : (rowData.addedByWeek4 === "Cons" ? "green" : (rowData.addedByWeek4 === "Sub" ? "orange" : (rowData.addedByWeek4 === "Acc" ? "#ca03fc" : "black"))),
                            isWeek: rowData.isWeek4
                        },
                        {
                            name: "5",
                            fields: "week5",
                            headers: `(${new Date(rowData.week5From || "").getDate()}/${new Date(rowData.week5From || "").getMonth() + 1}) to (${new Date(rowData.week5To || "").getDate()}/${new Date(rowData.week5To || "").getMonth() + 1})`,
                            data: rowData,
                            color: rowData.addedByWeek5 === "In" ? "blue" : (rowData.addedByWeek5 === "Cons" ? "green" : (rowData.addedByWeek5 === "Sub" ? "orange" : (rowData.addedByWeek4 === "Acc" ? "#ca03fc" : "black"))),
                            isWeek: rowData.isWeek5
                        },
                        {
                            name: "6",
                            fields: "week6",
                            headers: `(${new Date(rowData.week6From || "").getDate()}/${new Date(rowData.week6From || "").getMonth() + 1}) to (${new Date(rowData.week6To || "").getDate()}/${new Date(rowData.week6To || "").getMonth() + 1})`,
                            data: rowData,
                            color: rowData.addedByWeek6 === "In" ? "blue" : (rowData.addedByWeek6 === "Cons" ? "green" : (rowData.addedByWeek6 === "Sub" ? "orange" : (rowData.addedByWeek4 === "Acc" ? "#ca03fc" : "black"))),
                            isWeek: rowData.isWeek6
                        }
                    ];

                    const showDates = rowData?.pO_Id === tableData.tableData[0]?.pO_Id;

                    return <>
                        <div className="flex align-content-evenly justify-content-evenly">
                            {data.map((subEle) => {
                                return subEle.isWeek ? <div className="w-full">
                                    <div className="border-1 border-round border-200 pl-2 pt-2" style={{ height: "30px", width: "9rem", fontWeight: "bold" }}>{subEle.headers}</div>
                                    <div className={"border-1 border-round border-200 w-full flex justify-content-evenly"} style={{ height: "34px", width: "9rem" }}><div className="border-1 border-round border-200 w-7">{rowWeek(subEle.name, rowData)}</div><div className="border-1 border-round border-200 pt-2 pl-3 w-7 font-bold">{subEle.color === "blue" ? " In" : (subEle.color === "green" ? " C" : (subEle.color === "orange" ? " S" : (subEle.color === "#ca03fc" ? " A" : "")))}</div></div>
                                </div> : <></>
                            })}
                        </div>
                    </>
                }} />
                <Column field="monthTotalHours" header="Month Total Hours" />
                <Column field="totalWorkHours" header="Total Hours" />
            </DataTable>
            <Form singleData={modal.singleData} data={modal.data} open={modal.open} hideDialog={onHideTimesheetUpdate} loadTableData={() => loadTableData(filterData)} toast={props.toast} />
            <SendEmail open={openMailBox.open} multiData={openMailBox.multiData} hideDialog={() => {
                setOpenMailBox({ open: false, multiData: [] });
                setSelectedConsultant([]);
            }} toast={props.toast} />
            <Dialog visible={openRules} style={{ width: '80vw' }} header="" modal className="p-fluid" onHide={() => setOpenRules(false)}>
                <div className="mission-header">
                    <h2 className="mission-title">Guidelines</h2>
                    <p className="">
                        <p>1. <b>NC</b> - Not Collected.</p>
                        <p>2. <b>PNS</b> - Project Not Started.</p>
                        <p>3. <b>End</b> - Project Ended.</p>
                        <p>3. <b>WNS</b> - Week Not Started Yet.</p>
                        <p>5. If Timesheet Status - <b>Pending</b> : Hours background colour <span style={{ color: "yellow", backgroundColor: "#cacacaff", padding: "2px" }}>YELLOW</span></p>
                        <p>6. If Timesheet Status - <b>Verified</b> : Hours background colour <span style={{ color: "green" }}>GREEN</span></p>
                        <p>7. If Timesheet Status - <b>Rejected</b> : Hours background colour <span style={{ color: "red" }}>RED</span></p>
                        <p>8. Hours - <b>In</b> : Added By In-House User.</p>
                        <p>9. Hours - <b>C</b> : Added By Consultant.</p>
                        <p>10. Hours - <b>S</b> : Added By Subvendor.</p>
                        <p>11. Hours - <b>A</b> : Added By Subvendor Accounts Person.</p>
                        <p>12. <b>Glowing Consultant Name in <span style={{ color: "red" }}>RED</span> colour</b> : From last 3 weeks no Timesheet is been collected.</p>
                    </p>
                </div>
            </Dialog>
        </>
    );
}